import { cn } from "@/lib/utils";
import logoImg from "@/assets/optimized/logo.webp";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  inverted?: boolean;
}

export function Logo({ className, size = "md", inverted = false }: LogoProps) {
  const sizeClasses = {
    sm: "h-14",
    md: "h-[68px]",
    lg: "h-[108px]",
  };

  return (
    <img
      src={logoImg}
      alt="LoanGorilla.com.au"
      width={600}
      height={154}
      decoding="async"
      className={cn(sizeClasses[size], "w-auto", inverted && "brightness-0 invert", className)}
    />
  );
}
